import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'bidi-chat-launcher',
  templateUrl: './chat-launcher.component.html',
  styleUrls: ['./chat-launcher.component.scss']
})
export class ChatLauncherComponent {
  @Input() marker = 0;
  @Output() click = new EventEmitter();

  emit (e: Event) {
   // e.stopPropagation();
   // this.click.emit();
  }
}
